/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type BuySharedResultContainer_buyPage$ref = any;
export type BuySharedLayoutRefetchQueryVariables = {
    readonly uriRef: string;
    readonly localeOrigin: string;
    readonly isTrade: boolean;
    readonly showSeller: boolean;
    readonly first: number;
    readonly page: number;
    readonly rootId: string;
    readonly fetchBuy: boolean;
};
export type BuySharedLayoutRefetchQueryResponse = {
    readonly viewer: {
        readonly buyPage?: {
            readonly " $fragmentRefs": BuySharedResultContainer_buyPage$ref;
        } | null;
    } | null;
};
export type BuySharedLayoutRefetchQuery = {
    readonly response: BuySharedLayoutRefetchQueryResponse;
    readonly variables: BuySharedLayoutRefetchQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "uriRef",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "localeOrigin",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "isTrade",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "showSeller",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "first",
            "type": "Int!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "page",
            "type": "Int!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "rootId",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "fetchBuy",
            "type": "Boolean!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        } as any),
        ({
            "kind": "Variable",
            "name": "localeOrigin",
            "variableName": "localeOrigin"
        } as any),
        ({
            "kind": "Variable",
            "name": "page",
            "variableName": "page"
        } as any),
        ({
            "kind": "Variable",
            "name": "rootId",
            "variableName": "rootId"
        } as any),
        ({
            "kind": "Variable",
            "name": "uriRef",
            "variableName": "uriRef"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
    } as any), v5 = [
        ({
            "kind": "Variable",
            "name": "isTrade",
            "variableName": "isTrade"
        } as any),
        ({
            "kind": "Literal",
            "name": "page",
            "value": "searchAndBrowse"
        } as any)
    ], v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "amount",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "currency",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "convertedAmountList",
        "storageKey": null,
        "args": null,
        "concreteType": "ConvertedAmountList",
        "plural": true,
        "selections": [
            (v6 /*: any*/),
            (v7 /*: any*/)
        ]
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "type",
        "args": null,
        "storageKey": null
    } as any), v10 = [
        ({
            "kind": "Literal",
            "name": "formatType",
            "value": "MOBILE"
        } as any)
    ], v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "value",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "BuySharedLayoutRefetchQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "fetchBuy",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "buyPage",
                                    "storageKey": null,
                                    "args": (v1 /*: any*/),
                                    "concreteType": "BuyPageConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "BuySharedResultContainer_buyPage",
                                            "args": null
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "BuySharedLayoutRefetchQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "fetchBuy",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "buyPage",
                                    "storageKey": null,
                                    "args": (v1 /*: any*/),
                                    "concreteType": "BuyPageConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "BuyPageEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Item",
                                                    "plural": false,
                                                    "selections": [
                                                        (v3 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "isCustomizable",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "isMultiSku",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "localizedPdpUrl",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v4 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "vertical",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "displayPrice",
                                                            "storageKey": null,
                                                            "args": (v5 /*: any*/),
                                                            "concreteType": "ItemDisplayPriceType",
                                                            "plural": true,
                                                            "selections": [
                                                                (v8 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "quantityDisplay",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "percentageOff",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                (v9 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "showPriceLabel",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "showPriceVariability",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "lowestShipmentQuote",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "ShipmentQuote",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "complimentaryShipping",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "totalAmount",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "FinancialAmount",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "convertedAmountList",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "ConvertedAmountList",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v7 /*: any*/),
                                                                                (v6 /*: any*/)
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "serviceMethod",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "ShipmentServiceMethod",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "isWhiteGlove",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        (v2 /*: any*/)
                                                                    ]
                                                                },
                                                                (v2 /*: any*/)
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "classification",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "ItemClassification",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "creationDate",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "creators",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "ItemCreator",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "attribution",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "creator",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "Creator",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "displayName",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        (v2 /*: any*/)
                                                                    ]
                                                                },
                                                                (v2 /*: any*/)
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": "productPhotos",
                                                            "name": "photos",
                                                            "storageKey": "photos(limit:1)",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "limit",
                                                                    "value": 1
                                                                }
                                                            ],
                                                            "concreteType": "ItemPhoto",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "placeholder",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "smallPath",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "masterOrZoomPath",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "versions",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "ItemPhotoVersion",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "webPath",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        }
                                                                    ]
                                                                },
                                                                (v2 /*: any*/)
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "quickViewDisplay",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "QuickViewDisplayType",
                                                            "plural": false,
                                                            "selections": [
                                                                (v4 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": "mobileTitle",
                                                                    "name": "title",
                                                                    "args": (v10 /*: any*/),
                                                                    "storageKey": "title(formatType:\"MOBILE\")"
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "paragraphs",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "QuickViewParagraph",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "key",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "text",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": "mobileText",
                                                                            "name": "text",
                                                                            "args": (v10 /*: any*/),
                                                                            "storageKey": "text(formatType:\"MOBILE\")"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "measurement",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "ItemMeasurement",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": "dimensions",
                                                                    "name": "display",
                                                                    "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\"],separator:\" \")",
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "addLabel",
                                                                            "value": true
                                                                        },
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "fields",
                                                                            "value": [
                                                                                "height",
                                                                                "width",
                                                                                "depth",
                                                                                "diameter"
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "separator",
                                                                            "value": " "
                                                                        }
                                                                    ],
                                                                    "concreteType": "ItemDisplayMeasurementType",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "unit",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        (v11 /*: any*/)
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "size",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "ItemSize",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v11 /*: any*/)
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "browseUrl",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "categoryCode",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v2 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "categoryPath",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "contemporaryTrackingString",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "seller",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Seller",
                                                            "plural": false,
                                                            "selections": [
                                                                (v3 /*: any*/),
                                                                (v2 /*: any*/)
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": "displayPriceTracking",
                                                            "name": "displayPrice",
                                                            "storageKey": null,
                                                            "args": (v5 /*: any*/),
                                                            "concreteType": "ItemDisplayPriceType",
                                                            "plural": true,
                                                            "selections": [
                                                                (v8 /*: any*/),
                                                                (v9 /*: any*/)
                                                            ]
                                                        },
                                                        {
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "condition": "showSeller",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "seller",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "Seller",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "sellerProfile",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "SellerProfile",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "alias": null,
                                                                                    "name": "company",
                                                                                    "args": null,
                                                                                    "storageKey": null
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "BuySharedLayoutRefetchQuery",
            "id": "app-buyer-finding/234.0.0-2019-09-27T13:34:34.101Z/BuySharedLayoutRefetchQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'aa6cb4641dd89801ae6f039008a10696';
export default node;
